@if (portalEnabled) {
  <div class="portal">
    <fss-portal-toolbar></fss-portal-toolbar>
    @if (isUnEnabledForCurrentApp()) {
      <fss-portal-secondary-toolbar></fss-portal-secondary-toolbar>
    }
    @if (isExpandButtonShowing()) {
      <button (click)="toggleSidenav()" [style.left]="offset" class="toggle-btn">
        @if (!isSidenavExpanded()) {
          <fa-icon [icon]="['far', 'chevrons-left']"></fa-icon>
        }
        @if (isSidenavExpanded()) {
          <fa-icon [icon]="['far', 'chevrons-right']"></fa-icon>
        }
      </button>
    }
    @if (!isUnEnabledForCurrentApp() && !loginPopupOpen && showLandingPage && showAppSubMenu) {
      <div class="submenu">
        <fss-portal-app-submenu></fss-portal-app-submenu>
      </div>
    }
    <mat-drawer-container class="mat-drawer-container" #drawerContainer>
      <mat-drawer #matDrawer class="mat-drawer" disableClose="true" [mode]="isUnEnabledForCurrentApp() ? 'side' : 'over'" [position]="isUnEnabledForCurrentApp() ? 'start' : 'end'" [opened]="(isUnEnabledForCurrentApp() && isShowingSidenav()) || isOldMobileSidenavOpen()">
        @if (isUnEnabledForCurrentApp()) {
          <fss-portal-sidenav #sidenavMenu (drawerSizeChange)="updateDrawerContainerSize()"></fss-portal-sidenav>
        }
        @if (!isUnEnabledForCurrentApp() && isOldMobileSidenavOpen()) {
          <fss-portal-mobile-menu></fss-portal-mobile-menu>
        }
      </mat-drawer>
      <mat-drawer-content class="mat-drawer-content">
        @if (showSpinner$ | async) {
          <div [class.un]="isUnEnabledForCurrentApp()" class="loading-screen">
            <div class="spinner-container">
              <mat-spinner id="portal-spinner" class="un-spinner" strokeWidth="12" diameter="100"></mat-spinner>
              <!--the 2nd mat-spinner is being used to give the first one a background, so it matches the UN style figma-->
              @if (isUnEnabledForCurrentApp()) {
                <mat-spinner class="spinner-background" mode="determinate" value="100" color="white" strokeWidth="12" diameter="100"></mat-spinner>
              }
            </div>
            @if (isUnEnabledForCurrentApp()) {
              <span>
                Loading...
              </span>
            }
          </div>
        }
        <main
          id="frames-div"
          role="main"
          class="frames-div"
          [attr.aria-label]="'Main section'"
          >
          @if (loginPopupOpen) {
            <div class="showLoginWindow">
              <mat-icon class="icon" [svgIcon]="Icons.APP_WINDOW_TWO" aria-label="Copy To Clipboard"></mat-icon>
              <div class="header"> Waiting for Login </div>
              <div class="message"> Go to the login popup window to proceed...</div>
              <div>
                <button mat-flat-button color="primary" (click)="goToLoginPopup()">Show Login Window</button>
              </div>
            </div>
          }
          @if (!loginPopupOpen && showLandingPage && showSiteList) {
            <div class="district-sites-container">
              <fss-portal-district-sites></fss-portal-district-sites>
            </div>
          }
          @for (app of embeddableFrames; track app.app) {
            @if (!app.isExternal) {
              @if (app.app !== apps.CLM) {
                <iframe
                  id="{{ app.app }}"
                  class="iframe-class"
                  [src]="app.url | safe"
                  [attr.aria-label]="app.app"
                  [attr.data-app]="app.app"
                  [hidden]="isIframeHidden(app)"
                  allow="fullscreen"
                  allowfullscreen
                  >
                </iframe>
              }
              @if (app.app === apps.CLM) {
                <iframe
                  id="{{ app.app }}"
                  class="iframe-class"
                  [src]="app.url | safe"
                  [attr.aria-label]="app.app"
                  [attr.data-app]="app.app"
                  allow="camera; fullscreen"
                  allowfullscreen
                  [hidden]="isIframeHidden(app)"
                  >
                </iframe>
              }
            }
          }
          <fss-portal-juniper-sidecar-overlay></fss-portal-juniper-sidecar-overlay>
        </main>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
}
